import React from "react";
import "./ServicesPage.css";

const ServiceCard = ({ service }) => {
  return (
    
    <div className="service-card">
      <img src={service.image} alt={service.title} className="service-image" />
      <h3 className="service-title">{service.title}</h3>
      <p className="service-description">{service.description}</p>
    </div>

  );
};

export default ServiceCard;
